export default "__VITE_ASSET__CkCYfmPg__"